export default function MenuCameriereView({
  ordiniTavolo,
  tavolo,
  cameriere,
  numeroCoperti,
  categorie,
  categoriaSelezionata,
  piattiCategoria,
  carrello,
  showRiepilogo,
  setShowRiepilogo,
  setCategoriaSelezionata,
  aggiungiAlCarrello,
  modificaQuantita,
  rimuoviDalCarrello,
  onInviaOrdine
}) {
  return (
    <div className="cameriere-menu-container">

      {/* HEADER */}
      <header className="cameriere-menu-header">
        <h2>Tavolo {tavolo}</h2>
        <span>{cameriere}</span>
      </header>

      {/* =========================
          ORDINI ATTIVI TAVOLO
      ========================= */}
      {ordiniTavolo && ordiniTavolo.length > 0 && (
        <div className="ordini-attivi-section">
          <h3>Ordini attivi</h3>

          {ordiniTavolo.map((ordine) => {
            return (
              <div
                key={ordine.id}
                className={`ordine-card stato-${ordine.stato?.toLowerCase()}`}
              >
                <div className="ordine-header">
                  <span className="ordine-stato">
                    Stato: {ordine.stato?.charAt(0).toUpperCase() + ordine.stato?.slice(1)}
                  </span>
                  <span>Totale: € {ordine.totale?.toFixed(2)}</span>
                </div>

                <div className="ordine-items">
                  {ordine.items?.map((item, i) => (
                    <div key={i} className="ordine-item">
                      {item.quantity} × {item.name}
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* =========================
          MENU PIATTI
      ========================= */}
      <nav className="cameriere-categorie-navbar">
        <div className="cameriere-categorie-container">
          {categorie?.map((cat) => (
            <button
              key={cat.id}
              className={`cameriere-categoria-btn ${
                categoriaSelezionata === cat.nome ? "active" : ""
              }`}
              onClick={() => setCategoriaSelezionata(cat.nome)}
            >
              {cat.nome}
            </button>
          ))}
        </div>
      </nav>

      <div className="cameriere-menu-spacer" />

      <div className="cameriere-piatti-container">
        {piattiCategoria && piattiCategoria.length > 0 ? (
          piattiCategoria.map((piatto) => (
            <div
              key={piatto.id}
              className="cameriere-piatto-row"
            >
              <span>{piatto.nome}</span>
              <button onClick={() => aggiungiAlCarrello(piatto)}>
                +
              </button>
            </div>
          ))
        ) : (
          <div className="no-piatti">
            Nessun piatto disponibile
          </div>
        )}
      </div>

      {/* =========================
          CARRELLO NUOVO ORDINE
      ========================= */}
      {showRiepilogo && carrello.length > 0 && (
        <div className="cameriere-riepilogo-overlay">
          <div className="cameriere-riepilogo-panel">

            <h3>Nuovo ordine</h3>

            {carrello.map((item, index) => (
              <div key={index} className="cameriere-riepilogo-item">
                <button
                  onClick={() =>
                    modificaQuantita(item.id, item.custom, item.quantita - 1)
                  }
                >
                  −
                </button>

                <span>
                  {item.quantita} × {item.nome}
                </span>

                <button
                  onClick={() =>
                    modificaQuantita(item.id, item.custom, item.quantita + 1)
                  }
                >
                  +
                </button>

                <button
                  onClick={() =>
                    rimuoviDalCarrello(item.id, item.custom)
                  }
                >
                  ✕
                </button>
              </div>
            ))}

            <button
              className="cameriere-invia-ordine-btn"
              onClick={onInviaOrdine}
            >
              Invia nuovo ordine
            </button>

            <button
              className="cameriere-chiudi-carrello"
              onClick={() => setShowRiepilogo(false)}
            >
              Chiudi
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
